<template>
  <div class="columns is-multiline">
    <div class="column is-12">
      <div class="columns is-vcentered">
        <div class="column is-narrow">
          <SellerSelect :primary="primary" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StockviewStats',
  components: {
    SellerSelect: () => import('../components/StockCompareSellerSelect')
  },
  props: {
    primary: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('stockcompare/dashboard', ['myMakes', 'competitorMakes']),
    getMake() {
      const makes = this.primary ? this.myMakes : this.competitorMakes

      return makes.map(make => make.name)
    }
  }
}
</script>
